import { format, isValid, parse } from 'date-fns'

/**
 * Uses a round-trip check to ensure the input is complete — the parsed date
 * is only accepted if formatting it back produces the original input string.
 * This prevents premature parsing of partial input like "01/15/20".
 */
export const parseDateInput = (value: string): Date | null => {
  const attempt = parse(value, 'P', new Date())
  if (isValid(attempt) && format(attempt, 'P') === value) {
    return attempt
  }

  return null
}
